<template>
  <AutoDialogDrawer placement="centre" modal dismissible @close="$emit('close')">
    <template #title>{{ translate('Delete Login Policy') }}</template>
    <p>
      {{ translate('Are you sure you want to delete this login policy?') }}
      <strong class="text-nowrap">{{ translate('Version') }} {{ loginPolicy.version }}</strong>
    </p>
    <template #buttons>
      <BootstrapButton
        name="cancel"
        variant="secondary"
        :disabled="isDeleting"
        @click="$emit('close')"
      >
        {{ translate('Cancel') }}
      </BootstrapButton>
      <BootstrapButton name="delete" variant="danger" :disabled="isDeleting" @click="doDelete">
        {{ translate('Delete') }}
      </BootstrapButton>
    </template>
  </AutoDialogDrawer>
</template>

<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';
import {useLocalisation} from '@/composables/useLocalisation';

const {translate} = useLocalisation();

const loginPolicyStore = useLoginPolicyStore();

const props = defineProps<{loginPolicy: LoginPolicy}>();
const emit = defineEmits<{close: []}>();

const isDeleting = ref(false);

async function doDelete() {
  isDeleting.value = true;
  try {
    await loginPolicyStore.removeLoginPolicy(props.loginPolicy.id);
    emit('close');
  } finally {
    isDeleting.value = false;
  }
}
</script>
